/*
 * @Description 组件 现场人员
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-sub-item start -->
	<div class="index-sub-item sub-item-alarms sub-item-RB_site">
		<div class="sub-items-box-top"></div>
		<!-- sub-alarms-box -->
		<div class="sub-items-box-center sub-alarms-box">
			<div class="index-sub-title" >现场人员</div>
			<!-- sub-alarms-content start -->
			<div class="subSiteUserContent sub-alarms-content" v-resize="elPageResize">
				<!-- :style="{'max-height': (122 * dataList.length - 32) + 'px'}" -->
				
				<el-carousel v-if="contentOverFlag" height="132px" direction="vertical" :autoplay="true" arrow="always" indicator-position="none" @change="carouselItemChange" style="overflow: visible;">
					<el-carousel-item v-for="(itm, i) in dataList" :key="i" :style="{overflow: (i == currIndex ? 'visible' : 'hidden')}">
						
						<!-- sub-alarms-item start -->
						<div class="sub-alarms-item" v-if="index >= i" v-for="(item, index) in dataList" :key="index" v-show="i == currIndex || i == lastIndex" >
							<!-- alarm-item-box start -->
							<div :class="{'alarm-item-box cursor-pointer': true, 'alarm': item.alarmData.list.length > 0}" @click="handleItemBtn(item)" :title="extractTit(item)">
								<i class="item-alarm-icon"></i>
								<!-- item photo start -->
								<div class="rb-item-photo">
									<!-- 头像 -->
									<template>
										<img v-if="$checkEmpty(item.userData.portrait)" src="/static/images/icon-user-1.png"/>
										<img v-else :src="item.userData.portrait"/>
									</template>
								</div>
								<!-- item photo end -->
								
								<!-- 人员信息 start -->
								<span class="rb-item-text" style="color: #e6e6e6;">
									<span class="item-text-uname text-over">{{item.userData.userName}}</span>
									<i  class="item-text-ugroup text-over" >{{item.userData.groupName}}</i>
								</span>
								<span class="rb-item-text" style="color: #e6e6e6;">
									<span class="item-text-intoTime text-over" >进场时间：{{item.inoutData.intoTime}}</span>
								</span>
								<span v-if="false" class="rb-item-text text-over" >{{item.mapInfo.mapName}}&ensp;距起点约{{Math.round(item.posiData.pointX)}}米处</span>
							</div>
							<!-- alarm-item-box end -->
						</div>
						<!-- sub-alarms-item end -->
						
						<!-- sub-alarms-item start -->
						<div class="sub-alarms-item" v-if="index < i" v-for="(item, index) in dataList" :key="index" v-show="i == currIndex || i == lastIndex" >
							<!-- alarm-item-box start -->
							<div :class="{'alarm-item-box cursor-pointer': true, 'alarm': item.alarmData.list.length > 0}" @click="handleItemBtn(item)" :title="extractTit(item)">
								<i class="item-alarm-icon"></i>
								<!-- item photo start -->
								<div class="rb-item-photo">
									<!-- 头像 -->
									<template>
										<img v-if="$checkEmpty(item.userData.portrait)" src="/static/images/icon-user-1.png"/>
										<img v-else :src="item.userData.portrait"/>
									</template>
								</div>
								<!-- item photo end -->
								
								<!-- 人员信息 start -->
								<span class="rb-item-text" style="color: #e6e6e6;">
									<span class="item-text-uname text-over">{{item.userData.userName}}</span>
									<i  class="item-text-ugroup text-over" >{{item.userData.groupName}}</i>
								</span>
								<span class="rb-item-text" style="color: #e6e6e6;">
									<span class="item-text-intoTime text-over" >进场时间：{{item.inoutData.intoTime}}</span>
								</span>
								<span v-if="false" class="rb-item-text text-over" >{{item.mapInfo.mapName}}&ensp;距起点约{{Math.round(item.posiData.pointX)}}米处</span>
							</div>
							<!-- alarm-item-box end -->
						</div>
						<!-- sub-alarms-item end -->
						
					</el-carousel-item>
				</el-carousel>
				
				<template v-else >
					<!-- sub-alarms-item start -->
					<div class="sub-alarms-item" v-for="(item, index) in dataList" :key="index" >
						<!-- alarm-item-box start -->
						<div :class="{'alarm-item-box cursor-pointer': true, 'alarm': item.alarmData.list.length > 0}" @click="handleItemBtn(item)" :title="extractTit(item)">
							<i class="item-alarm-icon"></i>
							<!-- item photo start -->
							<div class="rb-item-photo">
								<!-- 头像 -->
								<template>
									<img v-if="$checkEmpty(item.userData.portrait)" src="/static/images/icon-user-1.png"/>
									<img v-else :src="item.userData.portrait"/>
								</template>
							</div>
							<!-- item photo end -->
							
							<!-- 人员信息 start -->
							<span class="rb-item-text" style="color: #e6e6e6;">
								<span class="item-text-uname text-over">{{item.userData.userName}}</span>
								<i  class="item-text-ugroup text-over" >{{item.userData.groupName}}</i>
							</span>
							<span class="rb-item-text" style="color: #e6e6e6;">
								<span class="item-text-intoTime text-over" >进场时间：{{item.inoutData.intoTime}}</span>
							</span>
							<span v-if="false" class="rb-item-text text-over" >{{item.mapInfo.mapName}}&ensp;距起点约{{Math.round(item.posiData.pointX)}}米处</span>
						</div>
						<!-- alarm-item-box end -->
					</div>
					<!-- sub-alarms-item end -->
				</template>
				
			</div>
			<!-- sub-alarms-content end -->
		</div>
		<!-- sub-alarms-box -->
		<div class="sub-items-box-bottom"></div>
	</div>
	<!-- index-sub-item end -->
</template>

/* JS */
<script>
	// API 进场
	import ApiApproach from '@/request/api-approach';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndRBSiteUser",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// data list
				dataList: [],
				// 人员ids
				userIds: [],
				
				// 报警开关
				alarmStateSwitchs: {},
				// 地图信息
				map_library: new this.HashMap(),
				// 标签用户
				map_tag_user: new this.HashMap(),
				// 标签报警
				map_tag_alarm: new this.HashMap(),
				// 标签位置
				map_tag_position: new this.HashMap(),
				// 进出场人员
				map_inout_user: new this.HashMap(),
				
				// flag 文本溢出
				contentOverFlag: false,
				// 最大容纳量
				maxItemsNum: 0,
				
				// 轮播 index current
				currIndex: 0,
				// 轮播 index last
				lastIndex: 0,
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			// 监听条件查询表单尺寸
			this.elPageResize();
			
			// 数据查询
			this.searchData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
			// 清除计时器
			this.endTimers();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 监听条件查询表单尺寸
			 * @Auth
			 * @Date
			 */
			elPageResize(data) {
				let height;
				
				// 空值
				if (this.$checkEmpty(data) || this.$checkEmpty(data.height)) {
					height = document.querySelector(".subSiteUserContent").offsetHeight;
				} else {
					height = data.height.replace(/px/g, '');
				}
				
				// 最大容纳量
				this.maxItemsNum = (height + 32) / 132;
				
				/*
				let contentOverFlag_last = this.contentOverFlag;
				// flag 文本溢出
				this.contentOverFlag = this.dataList.length > this.maxItemsNum;
				
				if (contentOverFlag_last != this.contentOverFlag) {
					// 轮播 index current
					this.currIndex = 0;
					// 轮播 index last
					this.lastIndex = 0;
				}
				*/
				
				// 更新数据 列表数据
				this.flushListData();
            },
            
            /**
			 * @Des 清除计时器
			 * @Auth
			 * @Date
			 */
			endTimers() {
				// 清除计时器
				if (this.timer_init_data != null) {
					clearTimeout(this.timer_init_data);
					this.timer_init_data = null;
				}
			},
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅 相关 信息
				this.sub_initLocalData = this.$pubsub.subscribe('initLocalData_site', (name, data) => {
					
					// 遍历data
					for(let key in data) {
						let fnName = null;
						switch (key) {
							case 'alarmStates':
								fnName = 'flushAlarmStates';
								break;
							case 'alarmStateSwitchs':
								fnName = 'flushAlarmStateSwitchs';
								break;
							case 'mapsInfo':
								fnName = 'flushMaps';
								break;
							case 'tagUsersInfo':
								fnName = 'flushTagUsers';
								break;
							case 'tagAlarmsInfo':
								fnName = 'flushTagAlarms';
								break;
							case 'tagPositionsInfo':
								fnName = 'flushTagPositions';
								break;
							default:
								fnName = null;
						};
						// 刷新数据
						fnName && typeof this[fnName] == 'function' && this[fnName](data[key]);
					};
					
					// 刷新 列表
					this.flushListData();
					
				});
				
				// 订阅消息 详情页
				this.sub_dataChange = this.$pubsub.subscribe('ApproachChange', (name, data) => {
					// 数据查询
					this.searchData();
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				// 取消订阅 相关 信息
				this.$pubsub.unsubscribe(this.sub_initLocalData);
				//取消订阅 详情页
				this.$pubsub.unsubscribe(this.sub_dataChange);
			},
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 点击条目btn
			 * @Auth
			 * @Date
			 */
			handleItemBtn(row) {
				// 空值 中止
				if (this.$checkEmpty(row)) {
					return false;
				}
				
				// 跳转到 首页
				this.$router.replace({path: '/manager/location/monitor'}, ()=>{}, ()=>{});
			},// handleItemBtn
			
			// ========================= 更新数据 start =========================
			/**
			 * @Des 更新数据 报警开关
			 * @Auth
			 * @Date 
			 */
			flushAlarmStateSwitchs(data) {
				// 报警开关
				this.alarmStateSwitchs = !this.$checkEmpty(data) ? Object.assign({}, data) : {};
			},
			/**
			 * @Des 更新数据 地图
			 * @Auth
			 * @Date
			 */
			flushMaps(rows) {
				// 清空 缓存
				this.map_library.clear();
				// 空值 中止
				if (this.$checkEmpty(rows)) return false;
				// 遍历
				rows.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return false;
					this.map_library.put(row.mapId, Object.assign({}, row));
				});
			},
			/**
			 * @Des 更新数据 user
			 * @Auth
			 * @Date 
			 */
			flushTagUsers(rows) {
				// 清空 缓存
				this.map_tag_user.clear();
				// 空值 中止
				if (this.$checkEmpty(rows)) return false;
				// 遍历
				rows.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return false;
					this.map_tag_user.put(row.tagId, Object.assign({}, row));
				});
			},
			/**
			 * @Des 更新数据 报警信息
			 * @Auth
			 * @Date
			 */
			flushTagAlarms(rows) {
				// 清空 缓存
				this.map_tag_alarm.clear();
				// 空值 中止
				if (this.$checkEmpty(rows)) return false;
				// 遍历
				rows.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return false;
					// 格式化 报警数据
					let formatRow = this.formatAlarmInfo(row.list, row.tagId);
					this.map_tag_alarm.put(row.tagId, Object.assign({}, row, {formatRow: formatRow}));
				});
			},
			/**
			 * @Des 更新数据 位置信息
			 * @Auth
			 * @Date
			 */
			flushTagPositions(rows) {
				// 清空 缓存
				this.map_tag_position.clear();
				// 空值 中止
				if (this.$checkEmpty(rows)) return false;
				// 遍历
				rows.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return false;
					this.map_tag_position.put(row.tagId, Object.assign({}, row));
				});
			},
			
			/**
			 * @Des 格式化 报警数据
			 * @Auth
			 * @Date
			 */
			formatAlarmInfo(stateList, tagId) {
				// 空值 中止
				if (this.$checkEmpty(stateList)) return null;
				
				// 记录
				var statusList = [];
				var alarmIds = [];
				var alarmNames = [];
				var alarmTimes = [];
				var alarmTimeLs = [];
				var alarmTypes = [];
				
				// 遍历
				stateList.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					
					var alarmId = row.id;
					var alarmName = row.alarmName;
					
					var time = '';
					if(this.$checkEmpty(row.time)) {
						time = '';
					} else {
						var _timeZone = !this.$checkEmpty(row.timeZone) ? row.timeZone : 8;
						time = this.$moment(row.time).format('YYYY-MM-DD HH:mm:ss');
					}
					var alarmTime = time;
					var alarmTimeL = row.time;
					
					var alarmType = row.code;
					
					statusList.push(row);
					alarmIds.push(alarmId);
					alarmNames.push(alarmName);
					alarmTimes.push(alarmTime);
					alarmTimeLs.push(alarmTimeL);
					alarmTypes.push(alarmType);
					
				});
				
				// 是否报警
				var alarm = statusList.length > 0 ? 1 : 0;
				
				var stateObj = {};
				// 更改缓存
				stateObj['statusList'] = Object.assign([], statusList);// [].concat(statusList);
				stateObj['alarm'] = alarm;
				stateObj['alarmIds'] = alarmIds;
				stateObj['alarmNames'] = alarmNames;
				stateObj['alarmTypes'] = alarmTypes;
				stateObj['alarmTimes'] = alarmTimes;
				stateObj['alarmTimeLs'] = alarmTimeLs;
				stateObj['id'] = tagId;
				stateObj['tagId'] = tagId;
				
				return stateObj;
			},
			
			/**
			 * @Des 更新数据 列表数据
			 * @Auth
			 * @Date
			 */
			flushListData() {
            	// data list
            	let dataList = [];
            	
				// 报警开关
				let alarmState_4 = Object.assign({}, this.alarmStateSwitchs[4]);
				let alarmState_4_flag = alarmState_4['show'] && alarmState_4['switch'];
				
				let rows = this.map_tag_user.values();
				// 遍历
				rows.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
					
					// 非当前进场 跳过
					if (this.userIds.indexOf(row.userId) == -1) return true;
					
					let tagId = row.tagId;
					
					// 定位信息
					let posiData = this.map_tag_position.get(tagId);
					// 空值
					if (this.$checkEmpty(posiData) || this.$checkEmpty(posiData.time)) return true;
					
					// 地图信息
					let mapInfo = this.map_library.get(posiData.mapId);
					// 空值 跳过
					if (this.$checkEmpty(mapInfo)) return true;
					
					// 报警信息
					let alarmData = this.map_tag_alarm.get(tagId);
					// 空值
					if (this.$checkEmpty(alarmData)) {
						alarmData = {formatRow: null, list: [], tagId: tagId};
					}
					
					// 超时 跳过
					if (alarmData.list.length == 0 && !alarmState_4_flag && posiData.status == 2) {
						return true;
					}
					
					// 进出场人员
					let inoutData = this.map_inout_user.get(tagId);
					
					dataList.push(Object.assign({}, {
						userData: Object.assign({}, row),
						alarmData: Object.assign({}, alarmData),
						posiData: Object.assign({}, posiData),
						mapInfo: Object.assign({}, mapInfo),
						inoutData: Object.assign({}, inoutData),
					}));
					
					return true;
					
				});
				// 排序
				dataList.sort((a, b) => {
					return b.alarmData.list.length - a.alarmData.list.length;
				});
				
				// 最大容纳量
				let maxItemsNum = Math.ceil(this.maxItemsNum) + 1 > dataList.length ? dataList.length : Math.ceil(this.maxItemsNum) + 1;
				let _dataList = Object.assign([], dataList).splice(0, maxItemsNum);
				// 排序
				_dataList.sort((a, b) => {
					return b.inoutData.inTime - a.inoutData.inTime;
				});
				
            	// data list
            	this.dataList = Object.assign([], _dataList);
            	
				let contentOverFlag_last = this.contentOverFlag;
            	// flag 文本溢出
				this.contentOverFlag = this.dataList.length > this.maxItemsNum;
				
				if (contentOverFlag_last != this.contentOverFlag) {
					// 轮播 index current
					this.currIndex = 0;
					// 轮播 index last
					this.lastIndex = 0;
				}
            },
            
			// ========================= 更新数据 end =========================
			
			//========================== 数据查询  start ==========================
			/**
			 * @Des 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData(){
				// 清除计时器
				if (this.timer_init_data != null) {
					clearTimeout(this.timer_init_data);
					this.timer_init_data = null;
				}
				
				// 查询 数据查询 current today history
				this.searchApproachData();
				
				// 计时器 数据更新
				this.timer_init_data = setTimeout(() => {
					// 数据查询
					this.searchData();
				}, 1*60*1000);
			},// searchData
			
			/**
			 * @Des 查询 进出场记录 today
			 * @Auth 
			 * @Date 
			 */
			searchApproachData() {
				// 人员 keys
				let keys = Object.assign([], this.map_inout_user.keySet());
				// 交互
				this.$request.postJsonRequest(ApiApproach.searchInoutApi, {
					projectId: this.$store.state.currentProjectId,
					keywords: '',
					startDate: new Date(new Date(new Date().toLocaleDateString()).getTime()),
					endDate: new Date(),
					status: 1,// 1 入场  2 离场
					orderBy: {
					  in_time: 'desc'
					},
					total: 0,
					startNum: 0,
					limit: 10000,
				}).then(result => {
					let rows = Object.assign([], result.rows);
					
					let y_m_d = this.$moment(new Date().getTime()).format('YYYY-MM-DD');
					// 今日0点
					let tdTime_0 = new Date([y_m_d, '00:00:00'].join(' ')).getTime();
					// 人员ids
					let userIds = [];
					rows.forEach((row, index) => {
						// 空值 跳过
						if (this.$checkEmpty(row) || this.$checkEmpty(row.tagId) || this.$checkEmpty(row.userId)) return true;
						
						// 进场时间
						row.intoTime = this.$checkEmpty(row.inTime) ? '----' : row.inTime > tdTime_0 ? this.$moment(row.inTime).format('HH:mm:ss') : this.$moment(row.inTime).format('YYYY-MM-DD HH:mm:ss');
						
						// 人员ids
						userIds.push(row.userId);
						// 进出场人员
						this.map_inout_user.put(row.tagId, Object.assign({}, row));
						
						let i = keys.indexOf(row.tagId);
						// 人员 keys
						i > -1 && keys.splice(i, 1);
					});
					// 人员ids
					this.userIds = Object.assign([], userIds);
					
					// 移除多余项
					keys.forEach((key, index) => {
						if (this.map_inout_user.containsKey(key)) {
							this.map_inout_user.remove(key);
						}
					});
					
					// 发布消息 获取全部数据
					this.$pubsub.publish('dataInfo_site', 'initAllDatas');
				}).catch(error => {
					console.error('查询进场数据异常', ApiApproach.getUserApi, error);
					// 进出场人员
					this.map_inout_user.clear();
				})
			},// searchApproachData
			
			/**
			 * @Des 查询 数据查询 current today history
			 * @Auth 
			 * @Date 
			 */
			searchApproachData_user() {
				// 交互 参数
				let formData = {projectId: this.$store.state.currentProjectId};
				// 当前
				formData.status = 1;
				
				this.$request.postJsonRequest(ApiApproach.getUserApi, formData).then(result => {
					// 人员ids
					this.userIds = Object.assign([], result.data);
					
					// 发布消息 获取全部数据
					this.$pubsub.publish('dataInfo_site', 'initAllDatas');
				}).catch(error => {
					console.error('查询进场数据异常', ApiApproach.getUserApi, error);
				})
			},// searchApproachData
			//========================== 数据查询  end ==========================
			
			/**
			 * @Des title
			 * @Auth 
			 * @Date 
			 */
			extractTit(row) {
				// 空值 中止
				if (this.$checkEmpty(row)) return '';
				
				// 人员信息
				let userData = Object.assign({}, row.userData);
				// 地图信息
				let mapInfo = Object.assign({}, row.mapInfo);
				// 位置信息
				let posiData = Object.assign({}, row.posiData);
				// 报警信息
				let alarmData = Object.assign({}, row.alarmData);
				// 进出场情况
				let inoutData = Object.assign({}, row.inoutData);
				
				let userName = !this.$checkEmpty(userData.userName) ? userData.userName : '----';
				let groupName = !this.$checkEmpty(userData.groupName) ? userData.groupName : '----';
				let mapName = !this.$checkEmpty(mapInfo.mapName) ? mapInfo.mapName : '----';
				let intoTime = !this.$checkEmpty(inoutData.intoTime) ? inoutData.intoTime : '---';
				
				let titleA = [
					['人员姓名', userName].join('：'),
					['人员分组', groupName].join('：'),
					['进场时间', intoTime].join('：'),
					['所在地图', mapName].join('：'),
				];
				
				let alarms = [];
				Object.assign([], alarmData.list).forEach((r, i) => {
					// 空值 跳过
					if (this.$checkEmpty(r) || this.$checkEmpty(r.alarmName)) return true;
					let t = !this.$checkEmpty(r.time) ? this.$moment(r.time).format('YYYY-MM-DD HH:mm:ss') : '----';
					alarms.push([r.alarmName, t].join('：'));
				});
				if (alarms.length > 0) {
					titleA.push('——————————————');
					titleA.push(alarms.join('\n'));
				}
				
				return titleA.join('\n');
				
			},
			
			/**
			 * @Des 轮播切换
			 * @Auth 
			 * @Date 
			 */
			carouselItemChange(currIndex, lastIndex) {
				// 轮播 index
				this.carouselIndex = currIndex;
				// 轮播 index current
				this.currIndex = currIndex;
				// 轮播 index last
				this.lastIndex = lastIndex;
			},
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndRBSiteUser.vue